import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";


export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Function to check if a link is active
  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Top Blue Line - Full Width */}
      <div className="w-full h-2 bg-[#1e73be]"></div>

      {/* Main Header Section - Full Width with centered content */}
      <div className="w-full bg-white py-4 relative overflow-hidden">
        {/* Right side Indian Flag with Gradient Fade (No Chakra) */}
        <div 
          className="absolute right-0 top-0 bottom-0 w-[35%] pointer-events-none hidden lg:block z-0"
          style={{
            background: `linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(to bottom, #FF9933 0%, #FF9933 33.33%, #FFFFFF 33.33%, #FFFFFF 66.66%, #138808 66.66%, #138808 100%)`
          }}
        />

        <div className="flex flex-col lg:flex-row items-center justify-center max-w-7xl mx-auto px-4 relative z-10">
          {/* Logo Section */}
          <div className="w-full lg:w-auto lg:absolute lg:left-4 lg:top-1/2 lg:-translate-y-1/2 flex justify-center mb-4 lg:mb-0">
            <img
              src="../images/nailogo.png"
              alt="NAI Logo"
              className="h-20 md:h-24 lg:h-44 w-auto object-contain"
            />
          </div>

          {/* Title and Tagline Section */}
          <div className="w-full text-center px-2">
            {/* Tagline */}
            <p className="text-blue-700 font-bold text-base sm:text-base md:text-lg lg:text-xl italic mb-1.5 sm:mb-2 tracking-wide">
              ENLIGHTEN INDIA THROUGH MEDIA
            </p>

            {/* Main Title */}
            <h1 className="text-3xl sm:text-xl md:text-2xl lg:text-3xl xl:text-5xl font-black text-red-500 uppercase sm:whitespace-nowrap leading-tight tracking-tight sm:tracking-normal">
              <span className="block sm:inline">NEWSMEDIA </span>
              <span className="block sm:inline">ASSOCIATION OF INDIA</span>
            </h1>

            <p className="text-lg md:text-2xl lg:text-2xl italic text-gray-700 mt-2 leading-tight">
              A Brand of DMCR Newsmedia Association
            </p>

            {/* Hindi Title */}
            <p className="text-lg md:text-2xl lg:text-3xl text-gray-700 mt-2 leading-tight">
              न्यूज़ मीडिया असोसिएशन ऑफ़ इंडिया
            </p>

            {/* Registration Info */}
            <p className="text-xs md:text-sm lg:text-base text-gray-500 mt-2">
              (Regd.By.Govt.of India. Under Section 8)
            </p>
          </div>
        </div>
      </div>

      {/* Navigation Bar - Full Width with centered content */}
      <div className="w-full bg-[#1e73be]">
        <div className="max-w-7xl mx-auto relative">
          <nav className="w-full rounded-lg shadow-lg">
            {/* Desktop Navigation */}
            <div className="hidden md:block w-full">
              <ul className="flex flex-wrap justify-center items-center py-2 lg:py-0 min-h-[3rem] gap-1 lg:gap-4 text-white font-semibold">
                <li>
                  <Link
                    to="/"
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 block text-sm lg:text-base ${
                      isActiveLink("/")
                        ? "bg-blue-300 text-white"
                        : "hover:bg-blue-400"
                    }`}
                  >
                    HOME
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 block text-sm lg:text-base ${
                      isActiveLink("/about")
                        ? "bg-blue-300 text-white"
                        : "hover:bg-blue-400"
                    }`}
                  >
                    ABOUT US
                  </Link>
                </li>
                <li>
                  <Link
                    to="/committee"
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 block text-sm lg:text-base ${
                      isActiveLink("/committee")
                        ? "bg-blue-300 text-white"
                        : "hover:bg-blue-400"
                    }`}
                  >
                    COMMITTEE
                  </Link>
                </li>
                <li className="relative group">
                  <button
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 text-sm lg:text-base flex items-center hover:bg-blue-500 ${
                       isActiveLink("/photos") || isActiveLink("/videos") ? "bg-blue-400" : ""
                    }`}
                  >
                    GALLERY
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                  </button>
                  <div className="absolute left-0 top-full pt-1 w-48 hidden group-hover:block z-50">
                    <div className="bg-white rounded-md shadow-lg py-1">
                      <Link to="/photos" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 hover:text-blue-400">PHOTOS</Link>
                      <Link to="/videos" className="block px-4 py-2 text-gray-800 hover:bg-blue-50 hover:text-blue-400">VIDEOS</Link>
                    </div>
                  </div>
                </li>
                
                <li>
                  <Link
                    to="/apply"
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 block text-sm lg:text-base ${
                      isActiveLink("/apply")
                        ? "bg-blue-300 text-white"
                        : "hover:bg-blue-400"
                    }`}
                  >
                    JOIN US
                  </Link>
                </li>
                <li>
                  <Link
                    to="/nai-news"
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 block text-sm lg:text-base ${
                      isActiveLink("/nai-news")
                        ? "bg-blue-300 text-white"
                        : "hover:bg-blue-400"
                    }`}
                  >
                    NAI NEWS
                  </Link>
                </li>
                <li>
                  <Link
                    to="/events"
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 block text-sm lg:text-base ${
                      isActiveLink("/events")
                        ? "bg-blue-300 text-white"
                        : "hover:bg-blue-400"
                    }`}
                  >
                    EVENTS
                  </Link>
                </li>
                <li>
                  <Link
                    to="/report-news"
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 block text-sm lg:text-base ${
                      isActiveLink("/report-news")
                        ? "bg-blue-300 text-white"
                        : "hover:bg-blue-400"
                    }`}
                  >
                    SUBMIT NEWS
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 block text-sm lg:text-base ${
                      isActiveLink("/contact")
                        ? "bg-blue-300 text-white"
                        : "hover:bg-blue-400"
                    }`}
                  >
                    CONTACT
                  </Link>
                </li>
                <li>
                  <Link
                    to="/faq"
                    className={`px-2 lg:px-4 py-2 rounded-md transition-colors duration-200 block text-sm lg:text-base ${
                      isActiveLink("/faq")
                        ? "bg-blue-300 text-white"
                        : "hover:bg-blue-400"
                    }`}
                  >
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            {/* Mobile Navigation */}
            <div className="md:hidden relative z-50">
              {/* Hamburger Button */}
              <div className="flex justify-between items-center px-4 py-3">
                <span className="text-white font-semibold text-base">Menu</span>
                <button
                  onClick={toggleMenu}
                  className="text-white focus:outline-none z-50"
                  aria-label="Toggle menu"
                >
                  <div className="w-6 h-6 flex flex-col justify-between">
                    <span
                      className={`block h-0.5 w-6 bg-white transition-all duration-300 ${
                        isMenuOpen ? "rotate-45 translate-y-2.5" : ""
                      }`}
                    ></span>
                    <span
                      className={`block h-0.5 w-6 bg-white transition-all duration-300 ${
                        isMenuOpen ? "opacity-0" : "opacity-100"
                      }`}
                    ></span>
                    <span
                      className={`block h-0.5 w-6 bg-white transition-all duration-300 ${
                        isMenuOpen ? "-rotate-45 -translate-y-2.5" : ""
                      }`}
                    ></span>
                  </div>
                </button>
              </div>

              {/* Mobile Menu Items */}
              <div
                className={`absolute top-full left-0 w-full bg-blue-600 rounded-b-lg shadow-lg transition-all duration-300 ease-in-out z-50 ${
                  isMenuOpen
                    ? "max-h-96 opacity-100"
                    : "max-h-0 opacity-0 overflow-hidden"
                }`}
              >
                <ul className="pb-4 px-4 space-y-2 text-white font-semibold animate-fadeIn">
                  <li>
                    <Link
                      to="/"
                      className={`block px-4 py-3 rounded-md transition-colors duration-200 border-b border-blue-500 text-base ${
                        isActiveLink("/")
                          ? "bg-blue-800 text-white"
                          : "hover:bg-blue-700"
                      }`}
                      onClick={closeMenu}
                    >
                      HOME
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className={`block px-4 py-3 rounded-md transition-colors duration-200 border-b border-blue-500 text-base ${
                        isActiveLink("/about")
                          ? "bg-blue-800 text-white"
                          : "hover:bg-blue-700"
                      }`}
                      onClick={closeMenu}
                    >
                      ABOUT US
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/committee"
                      className={`block px-4 py-3 rounded-md transition-colors duration-200 border-b border-blue-500 text-base ${
                        isActiveLink("/committee")
                          ? "bg-blue-800 text-white"
                          : "hover:bg-blue-700"
                      }`}
                      onClick={closeMenu}
                    >
                      COMMITTEE
                    </Link>
                  </li>
                  <li>
                    <div className="border-b border-blue-500 pb-2">
                        <span className="block px-4 py-2 text-blue-200 text-sm font-bold uppercase tracking-wider">Gallery</span>
                        <Link
                          to="/photos"
                          className={`block px-8 py-2 rounded-md transition-colors duration-200 text-base ${
                            isActiveLink("/photos") ? "bg-blue-800 text-white" : "hover:bg-blue-700"
                          }`}
                          onClick={closeMenu}
                        >
                          PHOTOS
                        </Link>
                        <Link
                          to="/videos"
                          className={`block px-8 py-2 rounded-md transition-colors duration-200 text-base ${
                            isActiveLink("/videos") ? "bg-blue-800 text-white" : "hover:bg-blue-700"
                          }`}
                          onClick={closeMenu}
                        >
                          VIDEOS
                        </Link>
                    </div>
                  </li>
                  <li>
                    <Link
                      to="/apply"
                      className={`block px-4 py-3 rounded-md transition-colors duration-200 border-b border-blue-500 text-base ${
                        isActiveLink("/apply")
                          ? "bg-blue-800 text-white"
                          : "hover:bg-blue-700"
                      }`}
                      onClick={closeMenu}
                    >
                      JOIN US
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/nai-news"
                      className={`block px-4 py-3 rounded-md transition-colors duration-200 border-b border-blue-500 text-base ${
                        isActiveLink("/nai-news")
                          ? "bg-blue-800 text-white"
                          : "hover:bg-blue-700"
                      }`}
                      onClick={closeMenu}
                    >
                      NAI NEWS
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/events"
                      className={`block px-4 py-3 rounded-md transition-colors duration-200 border-b border-blue-500 text-base ${
                        isActiveLink("/events")
                          ? "bg-blue-800 text-white"
                          : "hover:bg-blue-700"
                      }`}
                      onClick={closeMenu}
                    >
                      EVENTS
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/report-news"
                      className={`block px-4 py-3 rounded-md transition-colors duration-200 border-b border-blue-500 text-base ${
                        isActiveLink("/report-news")
                          ? "bg-blue-800 text-white"
                          : "hover:bg-blue-700"
                      }`}
                      onClick={closeMenu}
                    >
                      SUBMIT NEWS
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className={`block px-4 py-3 rounded-md transition-colors duration-200 border-b border-blue-500 text-base ${
                        isActiveLink("/contact")
                          ? "bg-blue-800 text-white"
                          : "hover:bg-blue-700"
                      }`}
                      onClick={closeMenu}
                    >
                      CONTACT
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/faq"
                      className={`block px-4 py-3 rounded-md transition-colors duration-200 text-base ${
                        isActiveLink("/faq")
                          ? "bg-blue-800 text-white"
                          : "hover:bg-blue-700"
                      }`}
                      onClick={closeMenu}
                    >
                      FAQ
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          {/* Overlay for mobile menu when open */}
          {isMenuOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
              onClick={closeMenu}
            ></div>
          )}
        </div>
      </div>
    </>
  );
}
